import { Injectable } from '@angular/core';
import { LanguageService } from './language.service';

@Injectable({ providedIn: 'root' })
export class PublicShared {
  static productMap = new Map<number, string>([
    [1, `Murabaha`],
    [2, 'Tawarruq'],
    [4, 'CreditCard'],
    [5, 'CreditCard'],
    [9, 'Combo Loan'],
  ]);
  static GProduct(productId: number): string | undefined {
    return PublicShared.productMap.get(productId);
  }
  getProductById(productId: number): string | undefined {
    return PublicShared.productMap.get(productId);
  }
}


@Injectable({ providedIn: 'root' })
export class Products {

  constructor( private languageService : LanguageService) {}
  get isLeft() {
    return this.languageService.CurrentLang.IsLeft;
  }

  static productMap = new Map<number, string>([
    [1, 'Installment Sales'],
    [2, 'Personal Finance'],
    [4, 'Credit Cards'],
    [5, 'Personal Finance + Credit Card'],
    [8, 'Baseeta'],
    [9, 'Combo Loan'],
  ]);
  static productMapAr = new Map<number, string>([
    [1, 'تقسيط المنتجات'],
    [2, 'التمويل الشخصي'],
    [4, 'بطاقة ائتمان'],
    [5, 'التمويل الشخصي + بطاقة ائتمان'],
    [8, 'بسيطة'],
    [9, 'Combo Loan'],
  ]);

  getProductName(id?: number) {
    if(id){
      if (this.isLeft)
        return Products.productMap.get(id);
      return Products.productMapAr.get(id);
    }
    return undefined;
  }
}
